import { render } from "./reel.vue?vue&type=template&id=113539c6&scoped=true"
import script from "./reel.vue?vue&type=script&lang=js"
export * from "./reel.vue?vue&type=script&lang=js"

import "./reel.vue?vue&type=style&index=0&id=113539c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-113539c6"],['__file',"src/js/components/reel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "113539c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('113539c6', __exports__)) {
    api.reload('113539c6', __exports__)
  }
  
  module.hot.accept("./reel.vue?vue&type=template&id=113539c6&scoped=true", () => {
    api.rerender('113539c6', render)
  })

}


export default __exports__